import React, { useEffect, useState } from "react";
import "./PaymentForm.css"; // Добавьте свой файл стилей или напишите стили в этом компоненте
import { useSelector } from "react-redux";
import chatApi from "../../api/chatApi";
import { selectEmailRegister } from "../Register/registerSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { selectUserEmail, selectUserId } from "../Login/loginSlice";

const PaymentForm = () => {
    const navigate = useNavigate();
    const email_register = useSelector(selectEmailRegister);
    const userEmail = useSelector(selectUserEmail)
    const userId = useSelector(selectUserId)
    const location = useLocation();
    const { isBinding = true } = location.state || {};

    const [amount, setAmount] = useState(isBinding ? "1" : ""); // Сумма
    const [error, setError] = useState(""); // Ошибка валидации

    const handleAmountChange = (e) => {
        const value = e.target.value;
        setAmount(value);

        // Валидация минимальной суммы
        if (!isBinding && value && Number(value) < 200) {
            setError("Минимальная сумма оплаты 200 рублей.");
        } else {
            setError(""); // Очистить ошибку, если всё верно
        }
    };

    // const handlePaymentSuccess = async () => {
    //     try {
    //         // const userId = email_register || userEmail;
    //         console.log("Создаём новый диалог для пользователя:", userId);
    //         const newDialog = await chatApi.startNewDialogBeginning(userId);
    //         console.log("Новый диалог успешно создан:", newDialog.data);

    //         localStorage.setItem("dialogId", newDialog.data.dialogId);

    //         navigate("/chat");
    //     } catch (err) {
    //         console.error("Ошибка при создании нового диалога:", err);
    //     }
    // };

    const handleSubmit = async (e) => {
        // Запрет отправки формы при ошибке
        if (!isBinding && (!amount || Number(amount) < 200)) {
            e.preventDefault();
            setError("Минимальная сумма оплаты 200 рублей.");
        }

        // try {
        //     console.log("Оплата успешно завершена!");
        //     await handlePaymentSuccess();
        // } catch (err) {
        //     console.error("Ошибка при обработке оплаты:", err);
        //     setError("Произошла ошибка при оплате. Попробуйте снова.");
        // }
    };

    useEffect(() => {
        if (!email_register && !userEmail) navigate('/login')
    }, []);
    return (
        <div className="payment-container">
            <div className='user_email'>
                {userEmail}
            </div>
            <h1 className="payment-title">{isBinding ? 'Привяжите карту': 'Форма оплаты'}</h1>

            <section className="payment-section">
                <h2 className="section-title">
                    {isBinding ? "" : "Пополнение счета"}
                </h2>
                <form
                    method="POST"
                    action="https://bottax.server.paykeeper.ru/create/"
                    className="payment-form"
                    onSubmit={handleSubmit}
                >
                    <div className="form-group">
                        <label htmlFor="clientid" className="form-label">
                            Идентификатор абонента:
                        </label>
                        <input
                            type="text"
                            id="clientid"
                            name="clientid"
                            defaultValue={ email_register || userEmail}
                            className="form-input"
                            readOnly
                        />
                    </div>

                    <div className="form-group">
                        {!isBinding && <label htmlFor="sum" className="form-label">
                            Сумма оплаты:
                        </label>}
                        {/* <input
                            type="text"
                            id="sum"
                            name="sum"
                            defaultValue={isBinding ? "1" : ""}
                            className="form-input"
                            placeholder={!isBinding ? "Введите сумму" : undefined}
                            readOnly={isBinding}
                        /> */}
                        <input
                            type={isBinding ? "hidden": "text"}
                            id="sum"
                            name="sum"
                            value={amount}
                            onChange={handleAmountChange}
                            className={`form-input ${error ? "input-error" : ""}`}
                            placeholder={!isBinding ? "Введите сумму" : undefined}
                            readOnly={isBinding}
                        />
                        {error && <p className="error-text">{error}</p>}
                    </div>

                    <input type="hidden" name="msgtype" value={isBinding ? "createbinding" : "payment"} />
                    <input type="hidden" name="user_result_callback" value={`https://chat.bottax.tech/success?email=${email_register || userEmail}`} />

                    <button type="submit" className="form-button">
                        {isBinding ? "Привязать карту" : "Пополнить"}
                    </button>
                </form>
            </section>
        </div>
    );
};

export default PaymentForm;
